import { centralizedAuth } from '@cimpress/simple-auth-wrapper';

import { logError } from 'src/loggingManager';
import { authClientId } from './settings';
import { initSdk } from './sdk';

const isDisabled = import.meta.env.NODE_ENV === 'test';

let auth: centralizedAuth | undefined = undefined;

if (!isDisabled) {
    auth = new centralizedAuth({
        // eslint-disable-line new-cap
        clientID: authClientId,
        redirectRoute: '/',
        nextUri: window.location.pathname + window.location.search,
        emitInitialTokenExpired: false,
    });
}

function setListeners() {
    auth?.on('tokenExpired', async () => {
        auth?.login({ nextUri: window.location.pathname, forceLogin: true });
        const token = auth!.getAccessToken();
        if (token) {
            await initSdk(token);
        }
    });
}

function initializeAuth(): Promise<void> {
    if (isDisabled) {
        return Promise.resolve();
    }

    return auth!
        .ensureAuthentication({ nextUri: window.location.pathname + window.location.search })
        .then(async (isAuthenticated) => {
            if (isAuthenticated) {
                const token = auth!.getAccessToken();
                if (!token) throw new Error('Auth succeeded but no token');
                setListeners();
                await initSdk(token);
            }
        })
        .catch((error) => {
            logError(`Failed to ensure authentication: ${error}`);
        });
}

export default Object.assign({}, auth, { initializeAuth });
